// lib
import { connect } from 'react-redux';

// components
import EcomPolicyModal from './EcomPolicyModal';

// redux selector
import {
  getEcomPolicyData,
  isEComAPIError,
  isEComAPIFetching,
} from 'shared/store/details/selectors';

// service
import { fetchEcomPolicyData as _fetchEcomPolicyData } from 'shared/store/details/services';

const mapStateToProps = (state: any) => ({
  ecomPolicyData: getEcomPolicyData(state),
  isEComAPIError: isEComAPIError(state),
  isEComAPIFetching: isEComAPIFetching(state),
});

const mapDispatchToProps = {
  fetchEcomPolicyData: _fetchEcomPolicyData,
};

export default connect(mapStateToProps, mapDispatchToProps)(EcomPolicyModal);
